export interface Category {
  key: string;
  url: string;
  image: string;
  tagKey: string;
}

export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=an%20elegant%20artistic%20flat%20lay%20of%20premium%20streetwear%20and%20fashion%20accessories%20including%20a%20white%20leather%20sneaker%20a%20folded%20sage%20hoodie%20round%20sunglasses%20and%20a%20minimal%20watch%20arranged%20in%20a%20loose%20organic%20composition%20on%20a%20warm%20cream%20background%20with%20soft%20directional%20natural%20light%20premium%20editorial%20e-commerce%20photography%20warm%20earthy%20muted%20tones%20high%20detail%20generous%20negative%20space%20contemporary%20European%20streetwear%20aesthetic&width=1600&height=900&seq=usfans-hero-02&orientation=landscape";

export const categories: Category[] = [
  {
    key: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    tagKey: "tag.shoes",
    image:
      "https://readdy.ai/api/search-image?query=a%20single%20premium%20white%20leather%20sneaker%20photographed%20from%20a%20low%20three%20quarter%20angle%20on%20a%20warm%20terracotta%20clay%20backdrop%20soft%20directional%20studio%20light%20rich%20leather%20texture%20editorial%20product%20photography%20warm%20earthy%20tones%20high%20detail%20generous%20negative%20space&width=600&height=600&seq=cat-shoes-02&orientation=squarish",
  },
  {
    key: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    tagKey: "tag.hoodies",
    image:
      "https://readdy.ai/api/search-image?query=a%20folded%20sage%20green%20oversized%20hoodie%20with%20visible%20drawstrings%20stacked%20neatly%20on%20a%20textured%20cream%20linen%20surface%20soft%20morning%20window%20light%20cozy%20editorial%20apparel%20photography%20warm%20neutral%20palette%20fabric%20detail%20clean%20minimal%20composition&width=600&height=600&seq=cat-hoodies-02&orientation=squarish",
  },
  {
    key: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    tagKey: "tag.tshirts",
    image:
      "https://readdy.ai/api/search-image?query=a%20crisp%20off%20white%20cotton%20t-shirt%20hanging%20on%20a%20wooden%20hanger%20against%20a%20soft%20blush%20pink%20wall%20gentle%20natural%20light%20minimalist%20fashion%20editorial%20warm%20pastel%20tones%20subtle%20fabric%20drape%20high%20detail%20clean%20composition&width=600&height=600&seq=cat-tshirts-02&orientation=squarish",
  },
  {
    key: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    tagKey: "tag.jackets",
    image:
      "https://readdy.ai/api/search-image?query=a%20tan%20suede%20bomber%20jacket%20laid%20flat%20on%20a%20warm%20beige%20background%20with%20soft%20overhead%20lighting%20rich%20material%20texture%20premium%20editorial%20fashion%20photography%20earthy%20neutral%20tones%20high%20detail%20minimal%20styling&width=600&height=600&seq=cat-jackets-02&orientation=squarish",
  },
  {
    key: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    tagKey: "tag.pants",
    image:
      "https://readdy.ai/api/search-image?query=folded%20olive%20green%20cargo%20pants%20styled%20in%20a%20neat%20stack%20on%20a%20warm%20sand%20colored%20surface%20soft%20diffused%20daylight%20editorial%20menswear%20photography%20muted%20earth%20tones%20fabric%20texture%20visible%20clean%20minimal%20layout&width=600&height=600&seq=cat-pants-02&orientation=squarish",
  },
  {
    key: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    tagKey: "tag.headwear",
    image:
      "https://readdy.ai/api/search-image?query=a%20cream%20corduroy%20baseball%20cap%20photographed%20from%20above%20on%20a%20soft%20mustard%20yellow%20background%20warm%20studio%20lighting%20premium%20editorial%20accessory%20photography%20cozy%20warm%20tones%20stitching%20detail%20clean%20composition&width=600&height=600&seq=cat-headwear-02&orientation=squarish",
  },
  {
    key: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    tagKey: "tag.sets",
    image:
      "https://readdy.ai/api/search-image?query=a%20coordinated%20beige%20and%20charcoal%20tracksuit%20folded%20together%20on%20a%20light%20oak%20wooden%20surface%20warm%20natural%20light%20premium%20athleisure%20editorial%20photography%20neutral%20earthy%20palette%20fabric%20texture%20minimal%20styling&width=600&height=600&seq=cat-sets-02&orientation=squarish",
  },
  {
    key: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    tagKey: "tag.underwear",
    image:
      "https://readdy.ai/api/search-image?query=folded%20premium%20boxer%20briefs%20in%20muted%20charcoal%20and%20off%20white%20arranged%20in%20a%20neat%20row%20on%20a%20soft%20cream%20background%20soft%20studio%20light%20understated%20editorial%20photography%20neutral%20tones%20cotton%20texture%20clean%20minimal%20layout&width=600&height=600&seq=cat-underwear-02&orientation=squarish",
  },
  {
    key: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    tagKey: "tag.jersey",
    image:
      "https://readdy.ai/api/search-image?query=a%20forest%20green%20and%20cream%20football%20jersey%20displayed%20flat%20with%20subtle%20fold%20lines%20on%20a%20warm%20light%20grey%20background%20soft%20directional%20light%20premium%20sportswear%20editorial%20earthy%20tones%20fabric%20detail%20clean%20composition&width=600&height=600&seq=cat-jersey-02&orientation=squarish",
  },
  {
    key: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    tagKey: "tag.accessories",
    image:
      "https://readdy.ai/api/search-image?query=a%20minimal%20leather%20strap%20watch%20and%20round%20sunglasses%20arranged%20artfully%20on%20a%20warm%20beige%20stone%20surface%20soft%20natural%20light%20premium%20accessory%20editorial%20photography%20warm%20neutral%20tones%20high%20detail%20generous%20negative%20space&width=600&height=600&seq=cat-accessories-02&orientation=squarish",
  },
  {
    key: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    tagKey: "tag.bags",
    image:
      "https://readdy.ai/api/search-image?query=a%20caramel%20brown%20leather%20backpack%20standing%20upright%20against%20a%20warm%20off%20white%20plaster%20wall%20soft%20window%20light%20premium%20bag%20editorial%20photography%20rich%20leather%20texture%20warm%20earthy%20tones%20minimal%20styling&width=600&height=600&seq=cat-bags-02&orientation=squarish",
  },
  {
    key: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    tagKey: "tag.belts",
    image:
      "https://readdy.ai/api/search-image?query=a%20rolled%20dark%20brown%20leather%20belt%20with%20a%20brass%20buckle%20photographed%20close%20up%20on%20a%20warm%20tan%20surface%20soft%20directional%20lighting%20premium%20accessory%20editorial%20rich%20texture%20warm%20neutral%20palette%20high%20detail&width=600&height=600&seq=cat-belts-02&orientation=squarish",
  },
  {
    key: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    tagKey: "tag.perfumes",
    image:
      "https://readdy.ai/api/search-image?query=an%20amber%20glass%20perfume%20bottle%20with%20a%20wooden%20cap%20on%20a%20warm%20terracotta%20background%20soft%20golden%20light%20luxury%20fragrance%20editorial%20photography%20warm%20tones%20elegant%20minimal%20styling%20high%20detail&width=600&height=600&seq=cat-perfumes-02&orientation=squarish",
  },
  {
    key: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    tagKey: "tag.other",
    image:
      "https://readdy.ai/api/search-image?query=an%20artful%20flat%20lay%20of%20assorted%20accessories%20including%20a%20knitted%20beanie%20a%20small%20keychain%20and%20a%20mini%20leather%20pouch%20on%20a%20soft%20warm%20grey%20linen%20surface%20soft%20natural%20light%20premium%20editorial%20photography%20neutral%20warm%20tones%20high%20detail&width=600&height=600&seq=cat-other-02&orientation=squarish",
  },
];